import styled, { css } from 'styled-components'
export const Content = styled.div`
    ${({theme})=> css`
    margin-top: 45px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-evenly;
`}
`
